export default __webpack_public_path__ + "static/landingImg-38e25f9796d6a73ec1a8bdca506a801c.png";